import {
  Grid,
  TextField,
  InputAdornment,
  Box,
  Stack,
} from "@mui/material";
import { Tickets, setAddReplyDialog } from "../../../app/slices/ticketsSlice";
import { useDispatch, useSelector } from "react-redux";
import { Controller, useForm } from "react-hook-form";
import { NumericFormat } from "react-number-format";
import FilePondInput from "../../../helpers/FilePondInput";
import {
  HiOutlineChatBubbleLeftEllipsis,
  HiOutlineChatBubbleBottomCenterText,
} from "react-icons/hi2";
import FormDialog, {
  SectionCard,
  SwitchCard,
} from "../../../components/FormDialog";

const AddReplyForm = (props) => {
  const dispatch = useDispatch();
  const _Ticket = useSelector((state) => state.tickets);

  const { control, reset, watch, register, handleSubmit, setValue } = useForm({
    defaultValues: {},
  });

  const onSubmit = (data) => {
    const info = new FormData();
    info.append("ticket_id", props.id);
    info.append("content", data.content);
    info.append("is_public", Number(data.is_public));
    data.attachments &&
      data.attachments.map((a) => info.append("attachments[]", a));

    dispatch(Tickets.addReply(info)).then((x) => {
      dispatch(setAddReplyDialog());
    });
  };

  const handleDialog = () => {
    dispatch(setAddReplyDialog());
  };

  return (
    <FormDialog
      open={_Ticket.addReplyDialog}
      onClose={handleDialog}
      icon={<HiOutlineChatBubbleLeftEllipsis />}
      title={"اضافة تعليق"}
      subtitle="اكتب التعليق وأرفق الملفات ثم احفظ"
      onSubmit={handleSubmit(onSubmit)}
    >
      <SectionCard
        icon={<HiOutlineChatBubbleBottomCenterText />}
        title="التعليق"
      >
        <Grid item xs={12}>
          <Controller
            name="content"
            control={control}
            render={({ field }) => (
              <TextField
                required
                size="small"
                label="التعليق"
                fullWidth
                {...field}
                sx={{ marginBottom: 1 }}
              />
            )}
          />
        </Grid>
        <Grid item xs={12}>
          <Controller
            name="attachments"
            control={control}
            render={({ field }) => (
              <Box>
                <FilePondInput
                  field={field}
                  required={false}
                  multiple={true}
                />
              </Box>
            )}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Controller
            name="is_public"
            control={control}
            defaultValue={true}
            render={({ field }) => (
              <SwitchCard
                field={field}
                label={field.value ? "عام" : "خاص"}
                onChange={(e) =>
                  setValue("is_public", e.target.checked)
                }
              />
            )}
          />
        </Grid>
      </SectionCard>
    </FormDialog>
  );
};

export default AddReplyForm;
